import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyCjqK6EzLP02dM-ottE0VjzsfKYeage3t0",
    authDomain: "taskflowy-9a9aa.firebaseapp.com",
    databaseURL: "https://taskflowy-9a9aa.firebaseio.com",
    projectId: "taskflowy-9a9aa",
    storageBucket: "taskflowy-9a9aa.appspot.com",
    messagingSenderId: "282995123250",
    appId: "1:282995123250:web:d7820421d183279536082b",
    measurementId: "G-X5RQWVEWFC"
  };

firebase.initializeApp(firebaseConfig);


export const auth = firebase.auth();
export const firestore = firebase.firestore();